import { NgModule } from '@angular/core';

import { ProtectedRoutingModule } from './protected-routing.module';
import { SharedModule } from '../shared/shared.module';
import { EmployeesModule } from './employees/employee.module';
import { BeneficiairesModule } from './beneficiaires/beneficiaires.module';
import { FormationsModule } from './formations/formations.module';
import { PlanningModule } from './planning/planning.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { StatistiquesModule } from './statistiques/statistiques.module';
import { MapModule } from './map/map.module';
import { MissionPlaceModule } from './mission-place/mission-place.module';
import { SpecialitesModule } from './specialites/specialites.module';
import { ProfileModule } from './profile/profile.module';
import { VehiculesModule } from './vehicules/vehicules.module';
import { RoutesModule } from './routes/routes.module';
import { AreaModule } from './area/area.module';
import { MissionTypeModule } from './mission-types/mission-type.module';
import { FundersModule } from './funders/funders.module';
import { MessagerieModule } from './messagerie/messagerie.module';
import { ParcoursModule } from './parcours/parcours.module';
import { PrescriberBookingComponent } from './prescriber-booking/prescriber-booking/prescriber-booking.component';
import { PrescriberBookingModule } from './prescriber-booking/prescriber-booking.module';
import { CareskillsModule } from './careskills/careskills.module';
import { CenterDepartmentsModule } from './center-departments/center-departments.module';
@NgModule({
	imports: [
		SharedModule,
		ProtectedRoutingModule,
		EmployeesModule,
		BeneficiairesModule,
		FormationsModule,
		PlanningModule,
		DashboardModule,
		StatistiquesModule,
		MapModule,
		MissionPlaceModule,
		SpecialitesModule,
		CareskillsModule,
		ProfileModule,
		VehiculesModule,
		RoutesModule,
		AreaModule,
		MissionTypeModule,
		FundersModule,
		MessagerieModule,
		ParcoursModule,
		PrescriberBookingModule,
		CenterDepartmentsModule
	],
	exports: []
})
export class ProtectedModule {}
